import { AdminService } from './../../../services/admin.service';
import { UserService } from 'src/app/services/user.service';
import { SeriesService } from './../../../services/series.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { SeriesNavigationComponent } from '../series-navigation/series-navigation.component';
import { first } from 'rxjs/internal/operators/first';
import * as jquery from 'jquery';
import { map, tap, concatMap } from 'rxjs/operators';
import { MinuteSecondsPipe } from 'src/app/helpers/pipes/minuteSeconds.pipe';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';
import * as NTW from 'number-to-words';
import { AuthService } from 'src/app/services/auth.service';
import { Role } from 'src/app/models';

declare var require: any;

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss'],
  providers: [ MinuteSecondsPipe ]
})
export class SummaryComponent implements OnInit {

  @ViewChild(UserNavigationComponent) userNavigation;
  @ViewChild(SeriesNavigationComponent) seriesNavigation;

  error = false;
  preloaderImage = require('../../../../assets/images/loader-big.svg');
  summary: any[];
  modulePoints = 5;
  seriesId: number;
  moduleId: number;
  modalText = 'Loading...';
  nonAdminRoles = [Role.Individual, Role.Manager, Role.Employee];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pageTitleService: Title,
    private seriesService: SeriesService,
    private userService: UserService,
    private adminService: AdminService,
    private authService: AuthService,
    private toMinute: MinuteSecondsPipe,
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.getRouteParams();

    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.loadData();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.loadAdminData();
          } else {
            this.loadData();
          }
        });
    }

  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Summary');
  }

  getRouteParams() {
    this.seriesId = this.route.snapshot.params.seriesId;
    this.moduleId = this.route.snapshot.params.moduleId;
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => this.userNavigation.user = user),

        // Get Series
        concatMap(() => this.seriesService.getSeries()),
        map(series => series.data.series),
        tap(series => {
          let moduleCount = 0;
          series.map(seriesData => {
            let words = NTW.toWords(seriesData.sequence_number + 1);
            words = words.charAt(0).toUpperCase() + words.slice(1);
            return seriesData.sequence_number = words;
          });
          this.seriesNavigation.series = series;

          // Gets the Video duration
          this.seriesNavigation.series.forEach(seriesData => {
            return seriesData.modules.forEach(module => {
              module.video_duration = this.toMinute.transform(module.video_duration);

              // Sets module total available points
              let totalAvailablePoints = 10;

              if (module.quiz == 1) {
                totalAvailablePoints += 5;
              }

              if (module.summary == 1) {
                totalAvailablePoints += 5;
              }

              module.totalAvailablePoints = totalAvailablePoints;

              // Sets the module count
              moduleCount += 1;
              module.moduleNo = moduleCount;
            });
          });
        }),

        // Get Summary
        concatMap(() => this.seriesService.getSeriesModules(this.seriesId)),
        map(module => module.data.series.modules),
        tap(module => {
          module.find(data => {
            if (data.id == this.moduleId) {

              // Pass data to UserNavigation component
              this.userNavigation.mobileNavText = 'Summary';
              this.userNavigation.seriesId = this.seriesId;
              this.userNavigation.moduleId = this.moduleId;
              this.userNavigation.hasModuleQuiz = (data.quiz?.length > 0) ? true : false;
              this.userNavigation.hasModuleSummary = (data.summary?.length > 0) ? true : false;

              this.summary = data?.summary;
              this.summary.sort(this.sortByValues);

              // Videos
              if (data.is_watched) {
                this.modulePoints += 5;
              }

              // Quiz
              if (data.quiz_completed) {
                this.modulePoints += 5;
              }

              // Exercise
              if (data.exercise_completed) {
                this.modulePoints += 5;
              }

            }
          });
        }),

        // Get User Statistics
        concatMap(() => this.userService.getUserStatistics()),
        map(stats => stats.data.tasks_completed),
        tap(stats => {
          const completedModules = stats.by_modules;

          if (completedModules.length > 0) {
            this.seriesNavigation.series.forEach(seriesData => {
                return seriesData.modules.forEach(module => {
                  completedModules.forEach(cSeries => {
                    cSeries.modules.forEach(cModule => {

                      // Get Video Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('video')) {
                        module.video_completed = true;
                      }

                      // Get Quiz Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('quiz')) {
                        module.quiz_completed = true;
                      }

                      // Get Exercise Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('exercise')) {
                        module.exercise_completed = true;
                      }

                      // Get Summary Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('summary')) {
                        module.summary_completed = true;
                      }

                      // Get Module Points
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('module_points')) {
                        module.points = cModule.module_points;
                      }
                    });
                  });
                });
              });
          }
        }),

      )
      .subscribe(
        response => {
          if (response) {
            // hide progress modal
            this.hideProgressModal();

            // Module Scrolling
            this.seriesNavigation.scrollToSpecificModule();
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  loadAdminData() {

    // Show progress modal
    this.showProgressModal();

    this.adminService.getProfile()
      .pipe(

        // Get User Details
        map(user => user.data.user),
        tap(user => this.userNavigation.user = user),

        // Get Series
        concatMap(() => this.seriesService.getSeriesAdminDashboard()),
        map(series => series.data.series),
        tap(series => {
          let moduleCount = 0;
          series.map(seriesData => {
            let words = NTW.toWords(seriesData.sequence_number + 1);
            words = words.charAt(0).toUpperCase() + words.slice(1);
            return seriesData.sequence_number = words;
          });
          this.seriesNavigation.series = series;

          // Gets the Video duration
          this.seriesNavigation.series.forEach(seriesData => {
            return seriesData.modules.forEach(module => {
              module.video_duration = this.toMinute.transform(module.video_duration);

              // Sets module total available points
              let totalAvailablePoints = 10;

              if (module.quiz == 1) {
                totalAvailablePoints += 5;
              }

              if (module.summary == 1) {
                totalAvailablePoints += 5;
              }

              module.totalAvailablePoints = totalAvailablePoints;

              // Sets the module count
              moduleCount += 1;
              module.moduleNo = moduleCount;
            });
          });
        }),

        // Get Summary
        concatMap(() => this.seriesService.getSeriesModulesAdminDashboard(this.seriesId)),
        map(module => module.data.series.modules),
        tap(module => {
          module.find(data => {
            if (data.id == this.moduleId) {

              // Pass data to UserNavigation component
              this.userNavigation.mobileNavText = 'Summary';
              this.userNavigation.seriesId = this.seriesId;
              this.userNavigation.moduleId = this.moduleId;
              this.userNavigation.hasModuleQuiz = (data.quiz?.length > 0) ? true : false;
              this.userNavigation.hasModuleSummary = (data.summary?.length > 0) ? true : false;

              this.summary = data?.summary;
              this.summary.sort(this.sortByValues);

              // Videos
              if (data.is_watched) {
                this.modulePoints += 5;
              }

              // Quiz
              if (data.quiz_completed) {
                this.modulePoints += 5;
              }

              // Exercise
              if (data.exercise_completed) {
                this.modulePoints += 5;
              }

            }
          });
        }),

        // Get User Statistics
        concatMap(() => this.adminService.getUserStatistics()),
        map(stats => stats.data.tasks_completed),
        tap(stats => {
          const completedModules = stats.by_modules;

          if (completedModules.length > 0) {
            this.seriesNavigation.series.forEach(seriesData => {
                return seriesData.modules.forEach(module => {
                  completedModules.forEach(cSeries => {
                    cSeries.modules.forEach(cModule => {

                      // Get Video Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('video')) {
                        module.video_completed = true;
                      }

                      // Get Quiz Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('quiz')) {
                        module.quiz_completed = true;
                      }

                      // Get Exercise Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('exercise')) {
                        module.exercise_completed = true;
                      }

                      // Get Summary Completion Status
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('summary')) {
                        module.summary_completed = true;
                      }

                      // Get Module Points
                      if (cSeries.series_id == seriesData.series_id && cModule.module_id == module.id &&
                        cModule.hasOwnProperty('module_points')) {
                        module.points = cModule.module_points;
                      }
                    });
                  });
                });
              });
          }
        }),

      )
      .subscribe(
        response => {
          if (response) {
            // hide progress modal
            this.hideProgressModal();

            // Module Scrolling
            this.seriesNavigation.scrollToSpecificModule();
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  redirectToDashboard() {
    const currentRole = this.authService.currentUserValue.role;
    if (currentRole && this.nonAdminRoles.indexOf(currentRole) >= 0) {
      this.updateNormalUser();
    } else {
      this.authService.getTokenDetails(this.authService.tokenValue)
        .subscribe(response => {
          if (response && response.data.role === Role.Admin) {
            this.updateAdminUser();
          } else {
            this.updateNormalUser();
          }
        });
    }

  }

  private updateNormalUser() {
    let willUpdateStats = false;
    let showExerciseConfirmation = false;

    this.userService.getUserStatistics()
      .pipe(first())
      .subscribe(
        statsData => {
          if (statsData.success) {
            if (statsData.data.tasks_completed.by_modules.length > 0) {
              const completedModules: any = statsData.data.tasks_completed.by_modules;

              // Check Summary Completion Status
              for (let i = 0; i < completedModules.length; i++) {
                for (let x = 0; x < completedModules[i].modules.length; x++) {
                  // If not exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId &&
                    !completedModules[i].modules[x].hasOwnProperty('summary')) {
                    willUpdateStats = true;
                    break;
                  }
                  // If exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId &&
                    completedModules[i].modules[x].hasOwnProperty('summary')) {
                    willUpdateStats = false;
                    break;
                  }
                  // If there's no any completed tasks on the current series yet
                  if (completedModules[i].series_id == this.seriesId &&
                    completedModules[i].modules.filter(item => item.module_id == this.moduleId).length == 0) {
                    willUpdateStats = true;
                    break;
                  }
                  // If current series id does not exists on the completed modules
                  if (completedModules.filter(item => item.series_id == this.seriesId).length == 0) {
                    willUpdateStats = true;
                    break;
                  }
                }
              }

              // Check Breath Exercise Completion Status
              for (let i = 0; i < completedModules.length; i++) {
                for (let x = 0; x < completedModules[i].modules.length; x++) {
                  // If not exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId &&
                    !completedModules[i].modules[x].hasOwnProperty('exercise')) {
                    showExerciseConfirmation = true;
                    break;
                  }
                  // If exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId &&
                    completedModules[i].modules[x].hasOwnProperty('exercise')) {
                    showExerciseConfirmation = false;
                    break;
                  }
                  // If there's no any completed tasks on the current series yet
                  if (completedModules[i].series_id == this.seriesId &&
                    completedModules[i].modules.filter(item => item.module_id == this.moduleId).length == 0) {
                    showExerciseConfirmation = true;
                    break;
                  }
                  // If current series id does not exists on the completed modules
                  if (completedModules.filter(item => item.series_id == this.seriesId).length == 0) {
                    showExerciseConfirmation = true;
                    break;
                  }
                }
              }

              // Update User Stats
              if (willUpdateStats) {
                this.updateUserStats(showExerciseConfirmation);
              } else {
                // if (showExerciseConfirmation) {
                //   // Show Breath Exercise Confirmation
                //   jquery('#exerciseConfirmation').show();
                // } else {
                //   // Redirect to Dashboard
                //   this.router.navigate(['/user/dashboard']);
                // }

                // Show Breath Exercise Confirmation
                jquery('#exerciseConfirmation').show();

              }

            }
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  private updateAdminUser() {
    let willUpdateStats = false;
    let showExerciseConfirmation = false;

    this.adminService.getUserStatistics()
      .pipe(first())
      .subscribe(
        statsData => {
          if (statsData.success) {
            if (statsData.data.tasks_completed.by_modules.length > 0) {
              const completedModules: any = statsData.data.tasks_completed.by_modules;

              // Check Summary Completion Status
              for (let i = 0; i < completedModules.length; i++) {
                for (let x = 0; x < completedModules[i].modules.length; x++) {
                  // If not exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId &&
                    !completedModules[i].modules[x].hasOwnProperty('summary')) {
                    willUpdateStats = true;
                    break;
                  }
                  // If exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId &&
                    completedModules[i].modules[x].hasOwnProperty('summary')) {
                    willUpdateStats = false;
                    break;
                  }
                  // If there's no any completed tasks on the current series yet
                  if (completedModules[i].series_id == this.seriesId &&
                    completedModules[i].modules.filter(item => item.module_id == this.moduleId).length == 0) {
                    willUpdateStats = true;
                    break;
                  }
                  // If current series id does not exists on the completed modules
                  if (completedModules.filter(item => item.series_id == this.seriesId).length == 0) {
                    willUpdateStats = true;
                    break;
                  }
                }
              }

              // Check Breath Exercise Completion Status
              for (let i = 0; i < completedModules.length; i++) {
                for (let x = 0; x < completedModules[i].modules.length; x++) {
                  // If not exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId &&
                    !completedModules[i].modules[x].hasOwnProperty('exercise')) {
                    showExerciseConfirmation = true;
                    break;
                  }
                  // If exists
                  if (completedModules[i].series_id == this.seriesId && completedModules[i].modules[x].module_id == this.moduleId &&
                    completedModules[i].modules[x].hasOwnProperty('exercise')) {
                    showExerciseConfirmation = false;
                    break;
                  }
                  // If there's no any completed tasks on the current series yet
                  if (completedModules[i].series_id == this.seriesId &&
                    completedModules[i].modules.filter(item => item.module_id == this.moduleId).length == 0) {
                    showExerciseConfirmation = true;
                    break;
                  }
                  // If current series id does not exists on the completed modules
                  if (completedModules.filter(item => item.series_id == this.seriesId).length == 0) {
                    showExerciseConfirmation = true;
                    break;
                  }
                }
              }

              // Update User Stats
              if (willUpdateStats) {
                this.updateAdminUserStats(showExerciseConfirmation);
              } else {
                // if (showExerciseConfirmation) {
                //   // Show Breath Exercise Confirmation
                //   jquery('#exerciseConfirmation').show();
                // } else {
                //   // Redirect to Dashboard
                //   this.router.navigate(['/user/dashboard']);
                // }

                // Show Breath Exercise Confirmation
                jquery('#exerciseConfirmation').show();

              }

            }
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  updateUserStats(showExerciseConfirmation: boolean) {
    // Updates User Stats when done with the summary
    this.userService.updateUserStatistics(this.moduleId, 'summary')
    .pipe(first())
    .subscribe(
      data => {
        if (data.success) {
          // if (showExerciseConfirmation) {
          //   // Show Breath Exercise Confirmation
          //   jquery('#exerciseConfirmation').show();
          // } else {
          //   // Redirect to Dashboard
          //   this.router.navigate(['/user/dashboard']);
          // }

          // Show Breath Exercise Confirmation
          jquery('#exerciseConfirmation').show();
        }
      },
      error => {
        // hide progress modal
        this.hideProgressModal();
        this.error = true;
      }
    );
  }

  updateAdminUserStats(showExerciseConfirmation: boolean) {
    // Updates User Stats when done with the summary
    this.adminService.updateUserStatistics(this.moduleId, 'summary')
    .pipe(first())
    .subscribe(
      data => {
        if (data.success) {
          // if (showExerciseConfirmation) {
          //   // Show Breath Exercise Confirmation
          //   jquery('#exerciseConfirmation').show();
          // } else {
          //   // Redirect to Dashboard
          //   this.router.navigate(['/user/dashboard']);
          // }

          // Show Breath Exercise Confirmation
          jquery('#exerciseConfirmation').show();
        }
      },
      error => {
        // hide progress modal
        this.hideProgressModal();
        this.error = true;
      }
    );
  }

  private sortByValues(a, b) {
    const bandA = a.sequence_number;
    const bandB = b.sequence_number;

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }

}
